import { getNotificationsHubApi } from '@ui/hooks/notificationsHubApiStore';
// Stops the SignalR connection on logout actions to ensure a clean shutdown
export const notificationsHubMiddleware = () => (next) => async (action) => {
    const result = next(action);
    const act = action;
    if (act?.type === 'auth/logout' || act?.type === 'auth/logoutApplicationOnly') {
        try {
            const api = getNotificationsHubApi();
            await api?.stop();
        }
        catch {
            // ignore
        }
    }
    return result;
};
